export enum ContactlessType {
  LEAVE_AT_DOOR = 'LEAVE_AT_DOOR',
  LEAVE_AT_RECEPTION = 'LEAVE_AT_RECEPTION'
}
